import React from 'react';

import { Grid } from '@mairistem/composants';

import { AssistantContext } from '@/contexts';
import Steps from '@/enums/Steps';
import InformationsConvention from './InformationsConvention';
import InformationsDeclaration from './InformationsDeclaration';

const StepDeclarationConvention = () => {
  const {
    conventionDeclaration: {
      dateDeclaration,
      dateConvention,
      attestationLienParente,
      attestationAdresseCommune,
      typeConvention,
      adresseConvention,
      adresseDeclaration,
      adresseCommune,
      aideMaterielle,
      valeurAide,
      regimeBien,
    },
    errors,
  } = React.useContext(AssistantContext);

  const errorsStep = errors?.[Steps.DeclarationConvention] || {};

  return (
    <Grid padded>
      <Grid.Row>
        <InformationsDeclaration
          attestationLienParente={attestationLienParente}
          attestationAdresseCommune={attestationAdresseCommune}
          dateDeclaration={dateDeclaration}
          adresseDeclaration={adresseDeclaration}
          adresseCommune={adresseCommune}
          errors={errorsStep}
        />
      </Grid.Row>
      <Grid.Row>
        <InformationsConvention
          typeConvention={typeConvention}
          dateConvention={dateConvention}
          adresseConvention={adresseConvention}
          aideMaterielle={aideMaterielle}
          valeurAide={valeurAide}
          regimeBien={regimeBien}
          errors={errorsStep}
        />
      </Grid.Row>
    </Grid>
  );
};

export default StepDeclarationConvention;
